import React from 'react';
import ChooseSeats from '../chooseSeats/ChooseSeats';
import FillPassengers from '../fillPassengers/FillPassengers';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import PaymentMethod from '../choosePaymentMethod/PaymentMethod';

export default function SelectBookingTabItems() {
  const {
    ridesCarriagesInfo,
    setDepartureChosenSeats,
    setReturnChosenSeats,
    departurePassengersForm,
    returnPassengersForm,
    departureChosenSeats,
    returnChosenSeats,
    savedPassengers,
    services,
    bookingData,
  } = useBooking();

  const isReturnWay = Boolean(bookingData?.return?.id);

  return [
    {
      key: 1,
      children: <ChooseSeats
        ride={ridesCarriagesInfo?.departure}
        statement={ridesCarriagesInfo?.statement}
        chosenSeats={departureChosenSeats}
        setChosenSeats={setDepartureChosenSeats}
        direction="departure"
      />,
    },
    {
      key: isReturnWay ? 2 : 100,
      children: <ChooseSeats
        ride={ridesCarriagesInfo?.return}
        statement={ridesCarriagesInfo?.statement}
        chosenSeats={returnChosenSeats}
        setChosenSeats={setReturnChosenSeats}
        direction="return"
      />,
    },
    {
      key: isReturnWay ? 3 : 2,
      children: <FillPassengers
        form={departurePassengersForm}
        departureChosenSeats={departureChosenSeats}
        rideId={bookingData?.departure?.id}
        savedPassengers={savedPassengers}
        services={services}
      />,
    },
    {
      key: isReturnWay ? 4 : 101,
      children: <FillPassengers
        form={returnPassengersForm}
        departureChosenSeats={returnChosenSeats}
        rideId={bookingData?.return?.id}
        savedPassengers={savedPassengers}
        services={services}
      />,
    }, {
      key: isReturnWay ? 5 : 3,
      children: <PaymentMethod />,
    }];
}
